import { Box } from '@pets-ui/Box/Box'
import './ecpay.css'

export interface ECPayCreditCardFieldsProps {
  isVisible: boolean
}

export const ECPayCreditCardFields = (props: ECPayCreditCardFieldsProps) => {
  const { isVisible } = props

  return (
    <Box display={isVisible ? 'block' : 'none'}>
      <div id="ECPayPayment" />
    </Box>
  )
}
